<template>
  <div class="ui-toggle">
    <svg v-if="!toggle" viewBox="0 0 50 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs></defs>
        <g id="Plan-index" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="plans-page-analytics-and-filter-panel-open-lg" transform="translate(-1130.000000, -120.000000)">
                <g id="Group-6" transform="translate(701.000000, 120.000000)">
                    <g id="Group-11" transform="translate(326.000000, 0.000000)">
                        <g id="toggle" transform="translate(128.000000, 13.500000) rotate(-180.000000) translate(-128.000000, -13.500000) translate(103.000000, 0.000000)">
                            <g id="Float">
                                <rect id="White-Background" fill="#C4E6EC" x="0" y="7" width="49.3548387" height="14" rx="7"></rect>
                                <circle class="ui-toggle__circle" id="Knob" cx="36.5625" cy="13.8125" r="12.9375"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>

    <svg v-if="toggle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <circle id="b" cx="29.25" cy="11.05" r="10.35"/>
        <filter x="-45.9%" y="-16.9%" width="191.8%" height="201.4%" filterUnits="objectBoundingBox" id="toggleA">
          <feMorphology radius=".5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
          <feOffset dy="3" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
          <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
          <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>
          <feMorphology radius=".5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter2"/>
          <feOffset dy="2" in="shadowSpreadOuter2" result="shadowOffsetOuter2"/>
          <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"/>
          <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" in="shadowBlurOuter2" result="shadowMatrixOuter2"/>
          <feMorphology radius=".5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter3"/>
          <feOffset dy="3" in="shadowSpreadOuter3" result="shadowOffsetOuter3"/>
          <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter3" result="shadowBlurOuter3"/>
          <feComposite in="shadowBlurOuter3" in2="SourceAlpha" operator="out" result="shadowBlurOuter3"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0510643116 0" in="shadowBlurOuter3" result="shadowMatrixOuter3"/>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"/>
            <feMergeNode in="shadowMatrixOuter2"/>
            <feMergeNode in="shadowMatrixOuter3"/>
          </feMerge>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <rect fill="#C4E6EC" y="5.6" width="39.484" height="11.2" rx="5.6"/>
        <!-- <use fill="#000" filter="url(#toggleA)" xlink:href="#b"/> -->
        <circle class="ui-toggle__circle" stroke-opacity=".1" stroke="#000" stroke-width=".5" cx="29.25" cy="11.05" r="10.6"/>
      </g>
    </svg>
    
  </div>
</template>

<script>
export default {
  name: 'ui-toggle',
  props: {
    toggle: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-toggle {

    &__circle {
        fill: #00B4FF;
    }

    & svg {
        width: 40px;
        height: 22px;
    }
}
</style>



// WEBPACK FOOTER //
// ui-toggle.vue?e1467aa0